import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText, Upload } from "lucide-react";
import api, { formatApiError } from "../../lib/api";

const MATERIALS = [
  { type: "apostila", title: "Apostila do evento", testid: "admin-upload-handout" },
  { type: "programacao", title: "Programação do evento", testid: "admin-upload-schedule" },
];

export default function MaterialsTab() {
  const [materials, setMaterials] = useState([]);
  const [busy, setBusy] = useState("");

  const load = useCallback(() => {
    api.get("/materials").then((r) => setMaterials(r.data)).catch((e) => console.error("Falha ao carregar materiais:", e));
  }, []);
  useEffect(() => { load(); }, [load]);

  const upload = async (type, file) => {
    if (!file) return;
    setBusy(type);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post(`/admin/materials/${type}`, fd);
      toast.success("Material enviado! Já disponível para os participantes.");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(""); }
  };

  const current = (type) => materials.find((m) => m.type === type);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl">
      {MATERIALS.map((m) => (
        <div key={m.type} className="card-metric space-y-4">
          <h3 className="text-lg font-semibold text-white flex items-center gap-2">
            <FileText size={18} className="text-[#00C8FF]" /> {m.title}
          </h3>
          {current(m.type) ? (
            <p className="text-xs text-slate-400 font-data">
              Atual: {current(m.type).filename} · {new Date(current(m.type).updated_at).toLocaleString("pt-BR")}
            </p>
          ) : (
            <p className="text-xs text-slate-500">Nenhum arquivo enviado ainda.</p>
          )}
          <label className="btn-secondary inline-flex items-center gap-2 cursor-pointer" data-testid={m.testid}>
            <Upload size={15} /> {busy === m.type ? "Enviando..." : "Enviar PDF"}
            <input type="file" accept=".pdf,.png,.jpg,.jpeg" className="hidden" disabled={busy === m.type}
              onChange={(e) => upload(m.type, e.target.files[0])} />
          </label>
        </div>
      ))}
    </div>
  );
}
